// EllipsisText.js
import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";

const EllipsisText = ({
  text,
  maxLength = 80, // Optional: Maximum characters before truncation
  tooltipPlacement = "top", // Tooltip position
  sx = {}, // Additional styles for the text
}) => {
  // Ensure text is a string, fallback to empty string if not
  const safeText = typeof text === "string" ? text : "";

  // Truncate text if it exceeds maxLength
  const truncatedText =
    safeText.length > maxLength
      ? `${safeText.substring(0, maxLength)}...`
      : safeText;

  // Determine if the text is truncated (i.e., if tooltip is needed)
  const isTruncated = safeText.length > maxLength;

  // Common Box component with truncation styles
  const textContent = (
    <Box
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        ...sx,
      }}
    >
      <Typography variant="body2" component="div">
        {truncatedText}
      </Typography>
    </Box>
  );

  // Only wrap in Tooltip if the text is truncated
  return isTruncated ? (
    <Tooltip title={safeText} placement={tooltipPlacement} arrow>
      {textContent}
    </Tooltip>
  ) : (
    textContent
  );
};

export default EllipsisText;
